import React, { useState } from "react";
import "./homescreen.css";

// Import the flyer image
import featuredFlyer from "../../assets/images/homeImage.jpeg";

const HomeScreen = () => {
  // State for image modal on mobile
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageSrc) => {
    // Check if screen width is less than 786px
    if (window.innerWidth < 786) {
      setSelectedImage(imageSrc);
    }
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  return (
    <div className="home-screen">
      <div className="home-screen-container">
        {/* Other home screen content */}

        {/* Featured Flyer Section */}
        <div className="featured-flyer-section">
          <div className="featured-flyer-container">
            <h3>Featured Event</h3>
            <div className="featured-flyer-item">
              <img
                src={featuredFlyer}
                alt="Featured Event Flyer"
                className="featured-flyer-image"
                onClick={() => handleImageClick(featuredFlyer)}
                onError={(e) => {
                  console.log(`Failed to load image: ${featuredFlyer}`);
                  e.target.style.display = "none";
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal for Mobile */}
      {selectedImage && (
        <div className="image-modal-overlay" onClick={handleCloseImageModal}>
          <div
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="image-modal-close"
              onClick={handleCloseImageModal}
            >
              &times;
            </button>
            <div className="image-container">
              <img
                src={selectedImage}
                alt="Featured Event Flyer"
                className="modal-image"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomeScreen;
